import parseArcaResponse from '../parseArcaResponse';
import { CreateWithdrawalRequestDto, WithdrawalRequest } from './interfaces/WithdrawalRequest';
import { GenericBackendResponse } from '../genericBackendResponse';

/**
 * Registra una solicitud de rescate sobre un plan concreto.
 *
 * No ejecuta nada en Caser: dispara un aviso al equipo, que continúa por email
 * con la persona. Sólo se admite una solicitud en curso por plan — si ya hay
 * una, el backend responde con un error de negocio que hay que mostrar.
 */
const createWithdrawalRequest = async (
	token: string,
	data: CreateWithdrawalRequestDto
): Promise<WithdrawalRequest> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/pension-plan-withdrawals`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify(data)
	});

	const body = await parseArcaResponse<GenericBackendResponse<WithdrawalRequest>>(response);

	return body.data;
};

export default createWithdrawalRequest;
